module.exports = __webpack_public_path__ + "img/alex-tampi_bottom-on.0c8458bd.png";